<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader
      class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center"
    >
      Mitra Pelatihan  
       <template v-if="role_status && role_status.status_create">
        <CButton
          color="success"
          class="btn-md ml-auto"
          @click="createData()"
        >Tambah</CButton>
       </template>
    </CCardHeader>
    <!-- Data Workshop -->
    <CCardBody>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <label for>Data Perhalaman</label>
            <select class="form-control" name id @change="changePageSize">
              <option>10</option>
              <option>25</option>
              <option>100</option>
              <option>Semua Data</option>
            </select>
          </div>
        </div>
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input type="text" name id 
              class="form-control" 
              placeholder="Cari Data ..."
              v-model="search" />
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>
             <template #namaMitraPelatihan="{item}">
              <td class="py-2">{{ item.namaMitraPelatihan ? item.namaMitraPelatihan : "-" }}</td>
            </template>
            <template #logoMitraPelatihan="{item}">
              <td>
                <button @click="bukaFileLogo(item.logoMitraPelatihan,'logo')" :class="item.logoMitraPelatihan == null ? 'btn btn-secondary p-0 px-3 shadow mx-auto' : 'btn btn-success p-0 px-3 shadow mx-auto'" :disabled="item.logoMitraPelatihan == null">
                  {{ item.logoMitraPelatihan ? 'Lihat file' : "File tidak ada" }}
                </button>
              </td>
            </template>
            <template #tandaTanganMitraPelatihan="{item}">
              <td>
                <button @click="bukaFile(item.tandaTanganMitraPelatihan,'ttd')" :class="item.tandaTanganMitraPelatihan == null ? 'btn btn-secondary p-0 px-3 shadow mx-auto' : 'btn btn-success p-0 px-3 shadow mx-auto'" :disabled="item.tandaTanganMitraPelatihan == null">
                  {{ item.tandaTanganMitraPelatihan ? 'Lihat file' : "File tidak ada" }}
                </button>
              </td>
            </template>
            <template #status="{item}">
              <td class="py-2 text-center">
                <font-awesome-icon icon="check" class="text-success" v-if="item.status == 1" />
                <font-awesome-icon icon="times" class="text-danger" v-else />
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 d-flex align-items-center">
                <template v-if="role_status && role_status.status_update">
                  <CButton v-c-tooltip="'Ubah'" color="info" class="btn-sm mr-1" square @click="updateData(item, index)">
                    <font-awesome-icon icon="edit" />
                  </CButton>&nbsp;&nbsp;
                </template>
                <template v-if="role_status && role_status.status_delete">
                <CButton v-c-tooltip="'Hapus'" color="danger" class="btn-sm" square @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination style="float:right" 
            :active-page.sync="currentPage" 
            :pages= "pagination.totalPages" 
            responsive 
            @click="pageChange"
          />
        </CCol>
      </CRow>
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm>
          <CRow>
            <CCol sm="12">
              <CInput
                class="font-weight-bold"
                label="Nama"
                placeholder="Masukkan Nama Mitra"
                v-model="formData.namaMitraPelatihan"
              />
            </CCol>

            <CCol sm="12 mb-2">
              <label for="uid-zwqayuopq3" class="font-weight-bold">Logo</label>
              <br />
              <div class="custom-file text-truncate">
                <input
                  type="file"
                  class="custom-file-input"
                  id="customFileLangHTML"
                  :required="actionPost == 'update'"
                  @change="fileUpload"
                />
                <label
                  class="custom-file-label"
                  for="customFileLangHTML"
                  data-browse="Unggah"
                >{{ typeof formData.logoMitraPelatihan === 'string' ? formData.logoMitraPelatihan : fileName }}</label>
              </div>
              <small class="text-danger">(*File harus bertipe jpg/png max. 10MB)</small>
            </CCol>
            <CCol sm="12 mb-3">
              <label for="uid-zwqayuopq3" class="font-weight-bold">Tanda Tangan</label>
              <br />
              <div class="custom-file text-truncate">
                <input
                  type="file"
                  class="custom-file-input"
                  id="customFileLangHTML"
                   :required="actionPost == 'update'"
                  @change="fileUpload2"
                />
                <label
                  class="custom-file-label"
                  for="customFileLangHTML"
                  data-browse="Unggah"
                >{{ typeof formData.tandaTanganMitraPelatihan === 'string' ? formData.tandaTanganMitraPelatihan : fileName2 }}</label>
              </div>
              <small class="text-danger">(*File harus bertipe jpg/png max. 10MB)</small>
            </CCol>
          </CRow>
          <div class="row">
            <CCol sm="12">
              <label for class="font-weight-bold">Status</label>
              <br />
              <div class="d-flex align-items-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    id="aktif"
                    value="1"
                    v-model="formData.status"
                  />
                  <label class="custom-control-label" for="aktif">Aktif</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    id="tidak_aktif"
                    value="0"
                    v-model="formData.status"
                  />
                  <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
                </div>
              </div>
            </CCol>
          </div>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Tambah</h6>
        </template>
        <template #footer class="mt-5">
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
    <!-- End Data MitraPelatihan -->
  </CCard>
</template>
<script>
import { required } from "vuelidate/lib/validators"
import MitraPelatihanService from "@/services/pelatihan/mitra-pelatihan.service";
import { AlertUtils } from "@/mixins/AlertUtils";
import { Pagination } from "@/mixins/Pagination";
import Utils from "@/services/utils.service";
import BaseUrl from "@/services/base-url";

const fields = [
  {
    key: "no",
    sorter: true,
    filter: false
  },
  {
    key: "namaMitraPelatihan",
    label: "Nama",
    sorter: true,
    filter: false
  },
  {
    key: "logoMitraPelatihan",
    label: "Logo",
    sorter: true,
    filter: false
  },
  {
    key: "tandaTanganMitraPelatihan",
    label: "Tanda Tangan",
    sorter: true,
    filter: false
  },
  {
    key: "status",
    _style: "text-align: center",
    sorter: false,
    filter: false
  },
  {
    key: "aksi",
    _style: "width: 12%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  name: "Mitra Pelatihan",
  mixins : [AlertUtils,Pagination],
  data() {
    return {
      items: [],
      actionPost: "",
      baseUrl : '',
      search: "",
      formData: {
        logoMitraPelatihan: "",
        namaMitraPelatihan: "",
        tandaTanganMitraPelatihan: "",
        status: "",
        idMitraPelatihan: ""
      },
      pagination: {
        totalPages: 0
      },
      fileName: "Masukkan Logo",
      fileName2: "Masukkan Tanda Tangan",
      fields,
      currentPage: 0,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      pageSize: "",
      collapseDuration: 0,
      content: [],
      indexed: 0,
      role_status: null
    };
  },

  mounted() {
    this.roleData();
    this.baseUrl = BaseUrl();
    this.getData("0", this.pageSize, this.search);
  },
  
  validations: {
    formData: {
      namaMitraPelatihan: { required },
      status: { required },
    },
  },

  methods: {
    roleData()
      {
        var user = JSON.parse(localStorage.getItem('user'));
        var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
        this.role_status = data;
      },
    changePageSize(e) {
      // comment console console.log(e.target.value);
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search);
    },

    cariData() {
      this.getData("0", this.pageSize, this.search);
    },

    pageChange() {
      this.getData(this.currentPage, this.pageSize, this.search);
    },
    alertError(message) {
      this.$swal.fire({
        title: "Peringatan!",
        text: message,
        icon: "error",
        showCancelButton: true
      });
    },
    alertSuccess() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },
    deleteData(item, index) {
      this.formData = item;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            let loader = this.$loading.show({
              container: false ? null : this.$refs.formContainer,
              canCancel: true,
              onCancel: this.onCancel,
            });
            MitraPelatihanService.deleteMitraPelatihan(this.formData)
              .then(response => {
                // comment console console.log(response);
                this.alertDeleteSuccess();
                this.getData(0, 10, 'default');
                loader.hide();
              })
              .catch(error => {
                this.alertError();
                // comment console console.log(error);
                loader.hide();
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    getData(currentPage, pageSize, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      MitraPelatihanService.getMitraPelatihan(currentPage, pageSize, filter)
      .then(response => {
        loader.hide();          
        // comment console console.log(response.data.data.content);
        this.items = response.data.data.content;
        this.pagination.totalPages = response.data.data.totalPages;
        this.currentPage = response.data.data.pageable.pageNumber + 1;
      })
      .catch(error => {
        loader.hide();
        // comment console console.log(error);
      });
    },

    createData() {
      this.myModal = true;
      this.formData = {};
      this.fileName = 'Masukkan Logo';
      this.fileName2 = 'Masukkan Tanda Tangan';
      this.actionPost = "insert";
      this.title = "Tambah";
    },

    updateData(item, index) {
      this.myModal = true;
      this.formData = item;
      this.fileName = 'Masukkan Logo';
      this.fileName2 = 'Masukkan Tanda Tangan';
      this.actionPost = "update";
      this.title = "Edit";

      // comment console console.log("ini update data", item);
    },

    postData() {

      this.$v.$touch();    
     
      if (this.actionPost == "insert") {
        if(this.$v.$invalid) {
          return;
        } else {
          this.insertData(this.formData);
        }
      } else if (this.actionPost == "update") {
        if(this.$v.$invalid) {
          return;
        } else {
          this.putData(this.formData);
        }
      }
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      // comment console console.log(formData.status);
      if (typeof formData.logoMitraPelatihan === "string") {
        delete formData.logoMitraPelatihan
      }
      if (formData.logoMitraPelatihan === null) {
        delete formData.logoMitraPelatihan
      }

      if (typeof formData.tandaTanganMitraPelatihan === "string") {
        delete formData.tandaTanganMitraPelatihan
      }
      if (formData.tandaTanganMitraPelatihan === null) {
        delete formData.tandaTanganMitraPelatihan
      }

      MitraPelatihanService.postMitraPelatihan(formData)
        .then(response => {
          this.myModal = false;
          loader.hide()
          this.alertSuccess();
          this.getData(0, 10, 'default');
        })
        .catch(error => {
          // comment console console.log(error);
          loader.hide()
          this.alertError(error.response.data.message);
        });
    },

    putData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      // comment console console.log("put");
      // comment console console.log(formData);
      if (typeof formData.logoMitraPelatihan === "string") {
        delete formData.logoMitraPelatihan
      }
      if (formData.logoMitraPelatihan === null) {
        delete formData.logoMitraPelatihan
      }

      if (typeof formData.tandaTanganMitraPelatihan === "string") {
        delete formData.tandaTanganMitraPelatihan
      }
      if (formData.tandaTanganMitraPelatihan === null) {
        delete formData.tandaTanganMitraPelatihan
      }
      MitraPelatihanService.putMitraPelatihan(formData)
        .then(response => {
          this.myModal = false;
          loader.hide()
          this.alertEditSuccess();

          this.getData("0", this.pageSize, this.search);
        })
        .catch(error => {
          // comment console console.log(error);
          loader.hide()

          this.alertError(error.response.data.message);
        });
    },

    fileUpload(e) {
      this.formData.logoMitraPelatihan = e.target.files[0];
      this.fileName = e.target.files[0].name;
      // comment console console.log(e.target.files);
    },
    fileUpload2(e) {
      this.formData.tandaTanganMitraPelatihan = e.target.files[0];
      this.fileName2 = e.target.files[0].name;
      // comment console console.log(e.target.files);
    },
    bukaFileLogo(file) {
      
      if (file != "" && file != null) {
        let routeData =
          this.baseUrl +
          "/files?filename=" +
          file +
          "&path=pelatihan@mitra@logo";
        window.open(routeData, "_blank");
        return false;
      } else {
        this.$swal.fire({
          title: "Informasi",
          text: "File Tidak Ditemukan.",
          icon: "info",
          confirmButtonText: "Tutup",
          showConfirmButton: true
        });
      }
    },
    bukaFile(file) {
      
      if (file != "" && file != null) {
        let routeData =
          this.baseUrl +
          "/files?filename=" +
          file +
          "&path=pelatihan@mitra@tandatangan";
        window.open(routeData, "_blank");
        return false;
      } else {
        this.$swal.fire({
          title: "Informasi",
          text: "File Tidak Ditemukan.",
          icon: "info",
          confirmButtonText: "Tutup",
          showConfirmButton: true
        });
      }
    },
  }
};
</script>